class HumanCapitalSpiral {
  constructor({
    eleSticky,
    eleDisplay,
  }) {
    this.idxPhase = 0;
    this.eleSpiralContainer = eleSticky;
    this.eleSpiralDisplayContainer = eleDisplay;
    this.listEleSpiralDisplay = [...this.eleSpiralDisplayContainer.children];
    this.listEleSpiralSticky = [...this.eleSpiralContainer.children];
    this.numOffsetDisplay = window.innerHeight * 0.5;
  }

  display({ eleSpiral }) {
    eleSpiral.classList.add("HumanCapitalSpiral--show");
  }
  hide({ eleSpiral }) {
    eleSpiral.classList.remove("HumanCapitalSpiral--show");
  }

  handleScroll() {
    // オブジェクトがnullの時は処理しない
    if (!this.listEleSpiralSticky) return;
    // スティッキーエリアに入るまでは処理しない
    if (this.listEleSpiralSticky[0].getBoundingClientRect().bottom > (0 + this.numOffsetDisplay)) {
      this.listEleSpiralSticky[1].classList.add("HumanCapitalSpiral--show");
      return;
    }
    // スティッキーエリアを抜けたからは処理しない
    if (this.listEleSpiralSticky[this.listEleSpiralSticky.length - 1].getBoundingClientRect().bottom < (0 + this.listEleSpiralDisplay[this.listEleSpiralSticky.length - 2].clientHeight)) {
      this.listEleSpiralSticky[this.listEleSpiralSticky.length - 2].classList.add("HumanCapitalSpiral--show");
      this.eleSpiralDisplayContainer.classList.add("spiral-inactive");
      return;
    }
    this.eleSpiralDisplayContainer.classList.remove("spiral-inactive");

    if (this.listEleSpiralSticky[this.idxPhase].getBoundingClientRect().bottom < 0 + this.numOffsetDisplay) {
      if (this.listEleSpiralSticky[this.idxPhase].classList.contains("progress-bottom")) {
        // 最後の要素は処理しない
        return;
      }
      // 自信の要素が画面外に抜けたら次の要素を表示
      console.log("next");

      // スパイラルトップとボトムからの切り替え時にアニメーション
      if (this.listEleSpiralSticky[this.idxPhase].classList.contains("progress-top")) {
        this.listEleSpiralDisplay[this.idxPhase + 1].classList.add("spiral-anim");
      } else if (this.listEleSpiralSticky[this.idxPhase].classList.contains("progress-4")) {
        this.listEleSpiralDisplay[this.idxPhase].classList.add("spiral-anim");
      } else {
        this.listEleSpiralDisplay[this.idxPhase].classList.remove("spiral-anim");
      }

      this.hide({ eleSpiral: this.listEleSpiralDisplay[this.idxPhase] });
      this.hide({ eleSpiral: this.listEleSpiralSticky[this.idxPhase] });
      this.idxPhase++;
      this.display({ eleSpiral: this.listEleSpiralDisplay[this.idxPhase] });
      this.display({ eleSpiral: this.listEleSpiralSticky[this.idxPhase] });
    } else if (this.listEleSpiralSticky[this.idxPhase - 1].getBoundingClientRect().bottom > 0 + this.numOffsetDisplay) {
      if (this.listEleSpiralSticky[this.idxPhase].classList.contains("progress-top")) {
        // 最初の要素は処理しない
        return;
      }
      // 自信の要素が画面内に入ったら前の要素を表示
      console.log("prev");

      // スパイラルトップとボトムからの切り替え時にアニメーション
      if (this.listEleSpiralSticky[this.idxPhase].classList.contains("progress-bottom")) {
        this.listEleSpiralDisplay[this.idxPhase + 1].classList.add("spiral-anim");
      } else if (this.listEleSpiralSticky[this.idxPhase].classList.contains("progress-1")) {
        this.listEleSpiralDisplay[this.idxPhase].classList.add("spiral-anim");
      } else {
        this.listEleSpiralDisplay[this.idxPhase].classList.remove("spiral-anim");
      }

      this.hide({ eleSpiral: this.listEleSpiralDisplay[this.idxPhase] });
      this.hide({ eleSpiral: this.listEleSpiralSticky[this.idxPhase] });
      this.idxPhase--;
      this.display({ eleSpiral: this.listEleSpiralDisplay[this.idxPhase] });
      this.display({ eleSpiral: this.listEleSpiralSticky[this.idxPhase] });
    }
    console.log(this.idxPhase);
  }

  setEventListeners() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }
}

export default HumanCapitalSpiral;
